import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import VueCookies from 'vue-cookies'


Vue.use(VueCookies)

/*
For background color:

Go to:    node_modules\vuetify\src\styles\settings\_variables.scss
and at the end of the file add this:

$material-dark:(
  "background": #5e2978
)

*/

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
